import React, { useRef,useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Button,
  ButtonIcon,
  Search,
  Checkbox,
  Icon,
  Slot,
  Modal,
  Dropdown,
  Breadcrumb
} from "pepsico-ds";
import Tooltip from "./tooltip.jsx";
import ArfFormAttributes from "./access_request_forms";
import "../requests/requests.css";
import requestsService from "../requests/requestsservice";
import { useLocation, useNavigate } from "react-router-dom";
import app_image from "../../assets/app_image.png";
import { useLoading } from "../../loader.jsx";
import { useTranslation } from "react-i18next";
import { toast,ToastContainer } from 'react-toastify';


// Define types for request options
interface RequestOption {
  label: string;
  desc: string;
  id: string;
  isBadge?: boolean;
  newApproverLevels?: Array<[]>,
  myidm?:boolean;
  currentAccessApp:boolean;
  newRequestInProgress:boolean;
  modifyDisableRequestInProgress:boolean;
  pepAppViewType:string;
}

interface CurrentAccessOption {
  label: string;
  desc: string;
  id: string;
  isBadge?: boolean;
  myidm?:boolean;
  newRequestInProgress:boolean;
  modifyDisableRequestInProgress:boolean;
  pepAppViewType:string;
}

type Toast = {
  id: string;
  duration: number;
  text: string;
  type: string;
  position: string;
};

interface SearchRequestsProps {}

  const SearchRequestsView: React.FC<SearchRequestsProps> = () => {
  const { REACT_APP_API_ENDPOINT } = process.env;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [searchText, setSearchText] = useState<string>("");
  const [requests, setRequests] = useState<RequestOption[]>([]);
  const [selectedItems, setSelectedItems] = useState<RequestOption[]>([]);
  const [currentAccessApps, setCurrentAccessApps] = useState<CurrentAccessOption[]>([]);
  const [currentAccesslist, setCurrentAccessList] = useState<CurrentAccessOption[]>([]);
  const [selectedId, setSelectedId] = useState<RequestOption | null>(null);
  const [toasts, setToasts] = useState<Toast[]>([]);
  const { showLoader, hideLoader } = useLoading();
  const [isLoading, setIsLoading] = useState(false);
  const [searchbyDivision, setSearchbyDivision] = useState(false);
  const [gpid, setGpid] = useState("");
  const [selectedOption, setSelectedOption] = useState<RequestOption[]>([]);
  const [roleList, setRolesList] = useState([]);
  const [selectedRequestTabIndex, setSelectedRequestTabIndex] = useState<number>(0);  
  const[divisions,setDivisions]= useState<DropdownItem[]>([]);
  const[functions,setFunctions]= useState<DropdownItem[]>([]);
  const[roles,setRoles]= useState<DropdownItem[]>([]);
  const [mode,setMode]= useState('');
  const [selectedDivision, setSelectedDivision] = useState('');
  const [selectedFunction, setSelectedFunction] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});
  const descRefs = useRef({});
  const [showMoreVisible, setShowMoreVisible] = useState({});

  const toggleExpand = (index) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const { t } = useTranslation();
  useEffect(() => {
    const updatedVisibility = {};
  
    currentAccessApps.forEach((item) => {
      const el = descRefs.current[item.id];
      if (el) {
        const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
        const maxHeight = lineHeight * 2;
        updatedVisibility[item.id] = el.scrollHeight > maxHeight;
      }
    });
  
    setShowMoreVisible(updatedVisibility);
  }, [currentAccessApps]);
  const callSearchAPI = async (val: string): Promise<void> => {
    try {
      showLoader();
      setIsLoading(true);
      const appList = await requestsService.getAppList(val,gpid);
      console.log('111111111111111111111',appList.length);
      if(appList.length == 0){
        // showToast(1,"No applications matched the specified keyword.",'error');
        toast.info("No applications matched the specified keyword.")
        hideLoader();
        setIsLoading(false);
      }
      // const myidmAppNames = ["PBNA Business Intelligence Dashboards","Contact Monkey Access Request","FEDEC Turkey","De La Mano Credential validation", "ATLAS FX (FOREIGN EXCHANGE)"];
      
      // const updatedAppsList = appList.map(app => ({
      //   ...app,
      //   myidm: myidmAppNames.includes(app.label),
      // }));
      setRequests(appList);
      
    } catch (error) {
      console.error("Failed to fetch app list:", error);
      hideLoader();
      setIsLoading(false);
    }
  };

  useEffect(()=>{
    console.log('4444444444444444444',state);
    
    if(state?.value){
      setGpid(state?.value);
    }
  },[state?.type, state?.value]);

  const showToast = (index: number, message: string, type: string) => {
    setToasts([
      {
        id: `toast-${index}`,
        duration: 10000,
        text: message,
        type: type,
        position: "bottom-right",
      },
    ]);
  };

  const removeSelectedAPP = (item) => {
    setSelectedItems((prevSelected) =>
      prevSelected.filter((i) => i.id !== item.id)
    );
  };

  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };
  
  const gotoMyidm = (item)=>{
    if(!item.myidm){
      if(state?.value){
        window.open("https://myidm.ite.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestAccessForOtherAssociate", "_blank");
      }else{
        window.open("https://myidm.ite.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestNewAccessForSelf", "_blank");
      }
    }
  }
  const handleToggle = (item) => {
    if(!item.myidm || item.currentAccessApp || item.newRequestInProgress || item.modifyDisableRequestInProgress){
      return;
    }
    else {
      setSelectedItems((prevSelected: any) => {
        const isSelected = prevSelected.some((i: any) => i.id === item.id);
        if (isSelected) {
          // Deselect: remove from array
          return prevSelected.filter((i: any) => i.id !== item.id);
        } else {
          // Select: add to array
          return [...prevSelected, item];
        }
      });
    }
  };
  
  
  // const divisions = Object.keys(data);
  // const functions = selectedDivision ? Object.keys(data[selectedDivision]) : [];
  // const roles = selectedDivision && selectedFunction ? data[selectedDivision][selectedFunction] : [];
  const [checkedItems, setCheckedItems] = useState(() => {
    const initialState = [];
    currentAccessApps.forEach(item => {
      initialState[item.id] = item.isBadge;
    });
    return initialState;
  });
  const { control } = useForm();
  const data = JSON.parse(localStorage.getItem("okta-token-storage") ?? "{}");
  const callCurrentAccessAPI = async (val: string): Promise<void> => {
    try {
      showLoader();
      setIsLoading(true);
      const currentAppList = await requestsService.getCurrentAccessAppList(val);
      // const myidmAppNames = ["PBNA Business Intelligence Dashboards","Contact Monkey Access Request","FEDEC Turkey","De La Mano Credential validation", "ATLAS FX (FOREIGN EXCHANGE)"];
      
      // const updatedAppsList = currentAppList.map(app => ({
      //   ...app,
      //   myidm: myidmAppNames.includes(app.label),
      // }));
      if(currentAppList.length > 0){
      console.log('before sorting',currentAppList);
      
      const sortedApps = [...currentAppList].sort((a, b) =>
        a.label.localeCompare(b.label)
      );

      setCurrentAccessApps(sortedApps);
      setCurrentAccessList(sortedApps);
      }
      else{
      setCurrentAccessApps(currentAppList);
      setCurrentAccessList(currentAppList);
      }
      
      hideLoader();
      setIsLoading(false);
    } catch (error) {
      console.error("Failed to fetch app list:", error);
      hideLoader();
      setIsLoading(false);
    }
  };
  
  type DropdownItem = {
    id: string;
    displayText: string;
  };

  const handleDivisionChange = (e) => {
    setSelectedDivision(e);
    
    if(roleList){
      const data = roleList['roleData'];
      const functionItems: DropdownItem[] =
      Object.keys(data[e[0]['id']]).map(func => ({
        id: func,
        displayText: func
      }))  
      setFunctions(functionItems);  
    }
    
    // setSelectedFunction('');
    // setSelectedRole('');
  };

  const handleFunctionChange = (e) => {
    setSelectedFunction(e);
    const data = roleList['roleData'];
    // Convert third-level values (roles) to DropdownItem[]
    const div = selectedDivision[0]['id'];
    const fun = e[0]['id'];
    const roleItems: DropdownItem[] = data[div][fun].map((role: string) => ({
        id: role,
        displayText: role
      }))

    setRoles(roleItems);
    setSelectedRole('');
  };

  const handleRoleChange = (e) => {
    setSelectedRole(e);
  };

  const callGetRolesAPI = async (): Promise<void> => {
    try {
      showLoader();
      setIsLoading(true);
      const currentAppList = await requestsService.getRolesList();
      setRolesList(currentAppList);
      const data = currentAppList['roleData'];      
      const dropdownItems: DropdownItem[] = Object.keys(data).map(item => ({
        id: item,
        displayText: item
      }));

      setDivisions(dropdownItems);
      console.log('0909009090909090',divisions);
      hideLoader();
      setIsLoading(false);
    //   // Convert second-level keys (functions) to DropdownItem[]
    //   const functionItems: DropdownItem[] = selectedDivision
    //   ? Object.keys(data[selectedDivision]).map(func => ({
    //       id: func.trim(),
    //       displayText: func.trim()
    //     }))
    //   : [];

    //   setFunctions(functionItems);
      
    // // Convert third-level values (roles) to DropdownItem[]
    // const roleItems: DropdownItem[] = selectedDivision && selectedFunction
    // ? data[selectedDivision][selectedFunction].map((role: string) => ({
    //     id: role.trim(),
    //     displayText: role.trim()
    //   }))
    // : [];

    // setRoles(roleItems);

    } catch (error) {
      console.error("Failed to fetch app list:", error);
      hideLoader();
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize(); // Initial check
    window.addEventListener('resize', checkScreenSize); // Listen for resize

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);
  
  useEffect(() => {
    if(!state?.value){
    if (!gpid && data?.accessToken?.claims?.gpid) {
      setGpid(data?.accessToken?.claims?.gpid);
    }
  }
    if (gpid) {
      callCurrentAccessAPI(gpid);
    }
    // callGetRolesAPI();
  }, [gpid,state?.value]);

  const divisionBySearchClick = ()=> {
    // if(val== 1){
      setSearchbyDivision(true);
      callGetRolesAPI();
    // }
    // if(val.id == 2){
    //   setSearchbyDivision(false);
    // }
  };

  const newRequestClick = () =>{
    if(state?.value){
      window.open("https://myidm.ite.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestAccessForOtherAssociate", "_blank");
    }else{
      window.open("https://myidm.ite.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestNewAccessForSelf", "_blank");
    }
    // let statePayload = {};
    // statePayload = { type: state?.type, value: state?.value };
    // navigate('/request-new-access',{ state: statePayload })
  }

  const updateSearchText = (val: string): void => {
    setSearchText(val);
  };

  const getAppSearch = (searchText: string) => {
    console.log('Search text:', searchText);

    if (searchText && searchText.trim() !== "") {
      const filtered = currentAccesslist.filter(app =>
        app.label.toLowerCase().includes(searchText.toLowerCase())
      );
      setCurrentAccessApps(filtered);
    } else {
      // Reset to full list when input is cleared
      setCurrentAccessApps(currentAccessApps);
    }
  };

  
  const getAppRequestTypes = (val: string): void => {
    val = searchText;
    if (!val) return;
    if (val?.length >= 3) {
      setSearchText(val);
      callSearchAPI(val);
    } else if (
      val?.length > 3 &&
      val?.substring(0, 3) === searchText?.substring(0, 3)
    ) {
      const results = requests.filter(
        (item) =>
          item?.label.substring(0, val?.length).toLowerCase() ===
          val?.toLowerCase()
      );
      setRequests(results);
    } else {
      setRequests([]);
    }
  };

  const {
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<{ my_selections: RequestOption[] }>({
    defaultValues: { my_selections: [] },
  });

  const getRolesAppsAPI = async (): Promise<void> => {
    try {
      showLoader();
      setIsLoading(true);
      const Jsondata ={
        division:selectedDivision[0]['id'],
        function:selectedFunction[0]['id'],
        role:selectedRole[0]['id']
      }
      const currentAppRoleList = await requestsService.getRoleAppList(Jsondata);
      // setSelectedId(currentAppList['appFormList']);
      // setSelectedItems(currentAppList['appFormList'])
      setSearchbyDivision(false);
      setRequests(currentAppRoleList);
      hideLoader();
      setIsLoading(false);
    } catch (error) {
      console.error("Failed to fetch app list:", error);
      hideLoader();
      setIsLoading(false);
    }
  };

  function gotoMyidmPage() {
    navigate("/myidmPortal");
  }

  const editApps = (mode)=> {
    console.log(currentAccessApps);
    console.log(checkedItems);
    setMode(mode)
    const filteredIds = currentAccessApps.filter(app => checkedItems[app.id]);
    // setSelectedOption(filteredData);
    setSelectedId(filteredIds);
    setSelectedItems(filteredIds);
  }


  const onFormSubmit = (): void => {
    console.log('111111111111111',mode);
    if(searchbyDivision){
      getRolesAppsAPI();
    }
    else{
      
    setSelectedOption(selectedItems)
    if(selectedOption){
    if (mode === 'NEW') {
    selectedOption["requestType"] = "NEW";
    } else if (mode === 'MODIFY') {
    selectedOption["requestType"] = "MODIFY";
    } else if (mode === 'DISABLE') {
    selectedOption["requestType"] = "DISABLE";
    }
    }
    setSelectedId(selectedItems);
    // setMode("NEW");
  }
  };

  const handleCheckboxChange = (id) => (event) => {
    console.log('3434343434343434',id,event.target);
    const foundItem:any = currentAccessApps.find(item => item.id === id);
    console.log(foundItem);
    if(!foundItem.myidm){
      window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?facesViewId=/app/page/association/user_association.jsp", "_blank");
    }
    else{
      setCheckedItems(prev => ({
        ...prev,
        [id]: event.target.checked,
      }));
    }
  };

const selectedValues = Object.entries(checkedItems)
  .filter(([_, checked]) => checked)
  .map(([id]) => id);

  const getActionInfo = (res: { resetSelection?: boolean }): void => {
  console.log("getActionInfo called with:", res);
  if (res?.resetSelection) {
    setSelectedOption(null);
    setSelectedId(null);
    setRequests([]);
    setCheckedItems([]);
    setSelectedItems([]);
    
  }
  };

  return (
    <div>
      
      <div
        id="landingPage"
        className="landingAlignments"
        style={{ display: "grid",fontSize:'12px',alignItems:'normal' }}
      >
        <Breadcrumb
          homeIcon={{
            icon: "home",
            onClick:()=>{
              navigate("/home")
            }
          }}
          breadcrumbs={[
            {
              label: t("nonArExtension.home"),
            },
            {
              label: <div onClick={()=>{
                navigate("/myidmPortal")
              }}>{t("nonArExtension.myidm")}</div>
            },
            {
              label: <div onClick={()=>{
                navigate("/request-access")
              }}>{t("myIdmPortal.request_access")}</div>
            }
          ]}
          className=""
          useAnchor
          style={{ marginBottom: "1rem !important" }}
        />
        
        {/* <div className="header-text-1 mb-2">{selectedId ? mode : ''} Request Access for {state?.value ? state?.value:'Self'}</div> */}
        <div className="header_ar-title pb-0">
          <h1> {selectedId ? mode
            ? mode.charAt(0).toUpperCase() + mode.slice(1).toLowerCase()
            : '' : ''} {t('RequestNewAccessForSelf.request_access_for')} {state?.value ? state?.value : t('RequestNewAccessForSelf.self')}
          </h1>
        </div>
      </div>
      <div id="search-requests">
        <div className="card card-layout mt-0">
          <div className="card-content">
            <div className="arfw-search-header flex-req" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 0 }}>
            {!selectedId && (<div style={{ textAlign: "left" }}>
                <div className="header-text-2">{t('RequestNewAccessForSelf.current_app_heading')}</div>
              </div>
            )}
              
            {!selectedId && (
              // <form className="" style={{display:'flex',gap:'1rem'}}>
                <div style={{display:'flex',gap:'1rem'}}>
                  {/* <Search
                    isAutoComplete
                    isClearable = {false}
                    onClear={(event) => getAppSearch(event.target.value)}
                    onSelectOption={(val: RequestOption) =>
                      setSelectedOption(val)
                    }
                    onSearch={(event) => getAppSearch(event)}
                    onUpdate={(event) => getAppSearch(event)}
                    placeholderText={t('RequestNewAccessForSelf.search')}
                    size="small"
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.stopPropagation();
                        getAppSearch(searchText);
                      }
                    }}
                    // suggestions={requests}
                  /> */}

                  <Button
                    className="pl-3 pr-3"
                    size="medium"
                    type="button"
                    style={{}}
                    disabled={selectedItems?.length > 0}
                    onClick={newRequestClick}
                    text={t('RequestNewAccessForSelf.request_new_access')}
                    variant="primary"
                  />
                  </div>
                  // </form>
            )}
            </div>
            {!selectedId && !searchbyDivision && (
              <div className="container">
                <div className="box box1 p-2">
                  {currentAccessApps?.length > 0 ?
                <div
                    style={{
                      maxHeight: "45vh", 
                      overflowY: "auto",
                      paddingRight: "8px",
                    }}
                  >
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}
                  >
                    {currentAccessApps.map((item) => {
                      const isSelected = selectedItems.some(
                        (i: any) => i.id === item.id
                      );
                      return (
                        <div
                          key={item.id}
                          className={`app-access-list ${
                            isSelected ? "selected" : ""
                          }`}
                          style={{
                            flex: "1 0 32%",
                            minWidth: isMobile ? "100%" : "150px",
                            maxWidth:'32%',
                            border: isSelected
                              ? "2px solid #007bff"
                              : "1px solid #ccc",
                            padding: "0px",
                            cursor: "pointer",
                            borderRadius: "6px",
                            justifyContent: !item.myidm ? 'space-between' :'',
                            paddingBottom: item.myidm ? '2rem':'0px',
                          }}
                          onClick={() => handleToggle(item)}
                        >
                        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', padding: '10px 10px 0 10px' }}>
                          <h4 className="app-list-header mb-0">
                            <img src={app_image} style={{ width: "25px", marginRight: "5px" }} alt="Pepsico" />
                            {item.label}
                          </h4>
                          {(item.newRequestInProgress || item.modifyDisableRequestInProgress) && (
                          <Tooltip
                            direction="auto"
                            maxWidth="70px"
                            text={t('RequestNewAccessForSelf.pending_req_message')}
                          >
                            <p style={{
                              display: 'flex',
                              fontSize: '12px',
                              background: '#F2B3BC',
                              borderRadius: '15px',
                              padding: '0.1rem 0.5rem',
                              alignItems: 'center',
                              gap: '2px'
                            }}>
                              <Icon
                                alt="alt value"
                                className="$color-icon-default"
                                icon="info"
                                size="medium"
                                style={{ fontSize: '14px' }}
                              />
                              <span>{t('RequestNewAccessForSelf.pending')}</span>
                            </p>
                          </Tooltip>
                          )}
                          {item?.currentAccessApp && (
                          <Tooltip
                            direction="auto"
                            maxWidth="70px"
                            text={t('RequestNewAccessForSelf.active_app')}
                          >
                            
                            <p style={{
                              display: 'flex',
                              fontSize: '12px',
                              background: '#0061C7',
                              borderRadius: '15px',
                              padding: '0.1rem 0.5rem',
                              alignItems: 'center',
                              gap: '2px',
                              color:'white'
                            }}>
                              <Icon
                                alt="alt value"
                                className="$color-icon-default"
                                icon="info"
                                size="medium"
                                style={{ fontSize: '14px',color:'white' }}
                              />
                              <span>{t('RequestNewAccessForSelf.active')}</span>
                            </p>
                          </Tooltip>
                          )}
                        </div>
                        {/* <p className="app-list-approval mb-0">
                          {item?.newApproverLevels?.length} level approval
                        </p> */}
                        {/* <p className="app-list-text mb-0" dangerouslySetInnerHTML={{__html: item.desc,}}></p>
                          */}
                        
                        {item.desc ? (
                          <>
                          <p ref={(el) => (descRefs.current[item.id] = el)}
                            style={{ padding: '0 10px' }}
                            className={`app-list-text mb-1 ${expandedItems[item.id] ? 'expanded' : 'collapsed'}`}
                            dangerouslySetInnerHTML={{ __html: item.desc }}
                          />
                          {showMoreVisible[item.id] && (
                            <div className="toggle-container pr-2" style={{ padding: '0 10px' }}>
                              <button
                                className="toggle-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleExpand(item.id);
                                }}
                              >
                                {expandedItems[item.id] ? 'Hide' : 'Show More'}
                              </button>
                            </div>
                          )}
                        </>
                        ):<p style={{minHeight:'20px'}}></p>}
                        {/* {item.currentAccessApp && (
                          <div className="p-2" style={{background:'lightgoldenrodyellow',borderRadius:'3%',width:'100%'}}>
                            <p className="app-list-text mb-2 mt-2">
                              You already have access to this application.
                            </p>
                          </div>
                          
                        )} */}
                        {!item.myidm && (
                          <div className="p-2 banner-idm" onClick={(e) => {
                            e.stopPropagation();
                            gotoMyidm(item);
                          }}>
                            <Icon
                              alt="alt value"
                              className="$color-icon-default"
                              icon="info"
                              size="medium"
                              style={{color: "var(--Primitives-White, #FFF)",paddingLeft:'5px'}}
                            />
                          <p className="app-list-text mb-2 mt-2">
                          {t('RequestNewAccessForSelf.app_not_migrated')}
                          </p>
                          {/* <Button
                            className=""
                            size="large"
                            style={{display:'flex',justifySelf:'right'}}
                            text="MyIDM"
                            onClick={(e) => {
                              e.stopPropagation();
                              gotoMyidm(item);
                            }}
                            variant="primary"
                          /> */}
                          <ButtonIcon
                            className=""
                            type="button"
                            color="Interaction/Active"
                            icon="arrow_forward"
                            label="Label"
                            onClick={(e) => {
                              e.stopPropagation();
                              gotoMyidm(item);
                            }}
                            size="medium"
                            style={{background:'transparent',color:'white',border:'none'}}
                            type="default"
                          />
                          </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  </div>
                  : isLoading ? null : <div className="w-100 d-flex justify-content-center align-items-center" style={{fontWeight: "500"}}>{t("RequestNewAccessForSelf.no_application_found")}</div>}
                  
                </div>
                
              </div>
            )}
            {!selectedId && searchbyDivision && (
              <div className="search-division">
                <form onSubmit={handleSubmit(onFormSubmit)}>
                <Controller
                  name="division"
                  control={control} 
                  render={({ field }) => (
                <>
                <Dropdown
                  childList={divisions?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                  className="mb-3"
                  feedbackType="info"
                  isClearable
                  isRequired
                  label="Division"
                  menuPosition="bottom-right"
                  placeholder="Search..."
                  selection="single"
                  selectedValue={field.value}
                  setSelectedValue={(value) => {
                    field.onChange(value);
                    handleDivisionChange(value);
                  }}
                  size="medium"
                  style={{}}
                  onKeyDown={(e) => e.preventDefault()}
                />
                {errors['division'] && <span className="error">This field is required</span>}
                </>
                )}
                />
                <Controller
                  name="function"
                  control={control} 
                  render={({ field }) => (
                <>
                <Dropdown
                  childList={functions?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                  className="mb-3"
                  feedbackType="info"
                  isClearable
                  isRequired
                  label="Function"
                  menuPosition="bottom-right"
                  placeholder="Search..."
                  selection="single"
                  selectedValue={field.value}
                  setSelectedValue={(value) => {
                    field.onChange(value);
                    handleFunctionChange(value);
                  }}
                  size="medium"
                  style={{}}
                  onKeyDown={(e) => e.preventDefault()}
                />
                {errors['function'] && <span className="error">This field is required</span>}
                </>
                )}
                />
                <Controller
                  name="role"
                  control={control} 
                  render={({ field }) => (
                <>
                <Dropdown
                  childList={roles?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                  className="mb-3"
                  feedbackType="info"
                  isClearable
                  isRequired
                  label="Role"
                  menuPosition="bottom-right"
                  placeholder="Search..."
                  selection="single"
                  selectedValue={field.value}
                  setSelectedValue={(value) => {
                    field.onChange(value);
                    handleRoleChange(value);
                  }}
                  size="medium"
                  style={{}}
                  onKeyDown={(e) => e.preventDefault()}
                />
                {errors['role'] && <span className="error">This field is required</span>}
                </>
                )}
                />
                </form>
              </div>
            )}
            
            {!selectedId && selectedItems.length > 0 && ( <hr
              className="custom-hr"
              style={{ marginBottom: "10px", marginTop: "16px" }}
            /> )}
            {!selectedId && selectedItems.length > 0 && (
              <div style={{display:isMobile ? '' :'flex',justifyContent:'space-between',alignItems:'center'}}>
                <div className="accountsAlign" style={{marginBottom:isMobile?'10px':'none'}}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <strong>{selectedItems?.length} {t('RequestNewAccessForSelf.selected')}</strong>
                </span>
                {selectedItems?.map((apps, index) => (
                  <span
                    key={index}
                    className="endPointInfo"
                    onClick={() => removeSelectedAPP(apps)} // pass index to remove
                    style={{ cursor: 'pointer', marginLeft: '8px' }}
                  >
                    {apps.label} {" X"}
                  </span>
                ))}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  className=""
                  type="button"
                  size="medium"
                  style={{}}
                  onClick={() => {
                    setRequests([]);
                    setSelectedItems([]);
                  }}
                  text={t('RequestNewAccessForSelf.deselect_all')}
                  variant="tertiary"
                />
                <Button
                  className=""
                  type="button"
                  size="medium"
                  style={{}}
                  onClick=
                  {() => {
                    setMode('DISABLE');
                    handleSubmit(onFormSubmit)();
                  }}
                  
                  text={t('RequestNewAccessForSelf.disable_access')}
                  variant="secondary"
                />
                <Button
                  className=""
                  type="button"
                  size="medium"
                  style={{}}
                  onClick={() => {
                    setMode('MODIFY')
                    handleSubmit(onFormSubmit)();
                  }}
                  text={t('RequestNewAccessForSelf.edit_access')}
                  variant="primary"
                />
              </div>
              </div>
            )}
          
            {selectedId && (
              <ArfFormAttributes
                selectedId={selectedId}
                setSelectRequest={getActionInfo} modeType={mode} uid={gpid} setSelectedId={setSelectedId}
              />
            )}
          </div>
        </div>
      </div>
      {/* <div id="search-requests">
        <div className="card card-layout">
          <div className="card-content">
            <div className="arfw-search-header flex-req" style={{marginBottom:'0px !important'}}>
            {!selectedId && (<div style={{ textAlign: "left" }}>
                <div className="header-text-2">Request app access</div>
                <p className="para-text mb-0">
                  Select up to 6 applications at the same time
                </p>
              </div>
            )}
              <div style={{ display: "flex", gap: "2px" }}>
                {!selectedId && (
                  <div className="">
                    <form className="" onSubmit={handleSubmit(onFormSubmit)}>
                      <div
                        className="d-flex justify-content-center col-12"
                        style={{ flexWrap: "wrap",padding:'0px',margin:'0px' }}
                      >
                        <Search
                          isAutoComplete
                          isClearable
                          onClear={() => {
                            setRequests([]);
                            setSelectedItems([]);
                          }}
                          onSelectOption={(val: RequestOption) =>
                            setSelectedOption(val)
                          }
                          onSearch={(event) => getAppRequestTypes(event)}
                          onUpdate={updateSearchText}
                          placeholderText="Type a search keyword"
                          size="medium"
                          autoComplete="off"
                          suggestions={requests}
                        />
                      </div>
                      <div>
                      <Button
                        className=""
                        type="button"
                        size="middle"
                        style={{marginTop:'-10px'}}
                        onClick={divisionBySearchClick}
                        text="Search by division"
                        variant="tertiary"
                      />
                      </div>
                      
                    </form>
                  </div>
                )}
              </div>
            </div>
            {!selectedId && !searchbyDivision && (
              <div className="container">
                <div className="box box1 p-2">
                  
                <div
                    style={{
                      maxHeight: "45vh", 
                      overflowY: "auto",
                      paddingRight: "8px",
                    }}
                  >
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}
                  >
                    {requests.map((item) => {
                      const isSelected = selectedItems.some(
                        (i: any) => i.id === item.id
                      );
                      return (
                        <div
                          key={item.id}
                          className={`app-access-list ${
                            isSelected ? "selected" : ""
                          }`}
                          style={{
                            flex: "1 0 30%",
                            minWidth: "150px",
                            border: isSelected
                              ? "2px solid #007bff"
                              : "1px solid #ccc",
                            padding: "10px",
                            cursor: "pointer",
                            borderRadius: "6px",
                          }}
                          onClick={() => handleToggle(item)}
                        >
                        <h4 className="app-list-header mb-0">{item.label}</h4>
                        <p className="app-list-approval mb-0">
                          {item?.newApproverLevels?.length} level approval
                        </p>
                       
                        {item.desc && (
                          <>
                            <p
                              className={`app-list-text mb-0 ${expandedItems[item.id] ? 'expanded' : 'collapsed'}`}
                              dangerouslySetInnerHTML={{ __html: item.desc }}
                            />
                            <div className="toggle-container">
                              <button
                                className="toggle-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleExpand(item.id);
                                }}
                              >
                                {expandedItems[item.id] ? 'Hide' : 'Show More'}
                              </button>
                            </div>
                          </>
                        )}
                        {item.currentAccessApp && (
                          <div className="p-2" style={{background:'lightgoldenrodyellow',borderRadius:'3%'}}>
                            <p className="app-list-text mb-2 mt-2">
                              You already have access to this application.
                            </p>
                          </div>
                          
                        )}
                        {!item.myidm && (
                          <div className="p-2" style={{background:'lightblue',borderRadius:'3%'}}>
                          <p className="app-list-text mb-2 mt-2">
                            This application hasn't been migrated to IAM Central yet. Please request access via MyIDM.
                          </p>
                          <Button
                            className=""
                            size="large"
                            style={{display:'flex',justifySelf:'right'}}
                            text="MyIDM"
                            onClick={(e) => {
                              e.stopPropagation();
                              gotoMyidm(item);
                            }}
                            variant="primary"
                          />
                          </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  </div>
                  
                </div>
                <div className="box box2">
                {selectedItems.length > 0 && (
                  <div
                    style={{
                      minHeight: "42vh",
                      background:
                        "var(--background-color-background-01, #F3F7FD)",
                      height: "auto",
                    }}
                  >
                    <p className="box2-text mb-0">New request</p>
                    <div className="pl-2">
                      {selectedItems.slice(0, 6).map((item: any) => (
                        <div className="badge-header" key={item.id}>
                            <p className="badge-text mb-0">{item.label}</p>
                            <p className="mb-0" onClick={() => removeSelectedAPP(item)} style={{ cursor: "pointer" }}>x</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                  {selectedItems.length === 0 && (
                      <div
                        style={{
                          minHeight: isMobile? "22vh":"42vh",
                          background: "var(--background-color-background-01, #F3F7FD)",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <p className="box2-text">Current Access</p>

                        <div
                          className="pl-2"
                          style={{
                            overflowY: "auto",
                            flexGrow: 1,
                            paddingRight: "8px",
                            maxHeight:isMobile ? '15vh':'none',

                          }}
                        >
                          {currentAccessApps.map((item) => (
                            <Checkbox
                              key={item.id}
                              className=""
                              size="small"
                              checked={checkedItems[item.id]}
                              onChange={handleCheckboxChange(item.id)}
                              text={item.label}
                              style={{color: !item.myidm ? 'red' :''}}
                            />
                          ))}
                        </div>

                        <div
                          className="d-flex m-2"
                          style={{
                            justifyContent: "space-around",
                            borderTop: "1px solid #ccc",
                            paddingTop: "8px",
                            backgroundColor: "#F3F7FD",
                          }}
                        >
                          <Button
                            className=""
                            size="small"
                            text="Edit"
                            onClick={() => editApps('MODIFY')}
                            variant="tertiary"
                            disabled={checkedItems.length === 0} 
                          />
                          <Button
                            className=""
                            size="small"
                            text="Disable"
                            onClick={() => editApps('DISABLE')}
                            variant="tertiary"
                            disabled={checkedItems.length === 0} 
                          />
                        </div>
                      </div>
                    )}
                </div>
              </div>
            )}
            {!selectedId && searchbyDivision && (
              <div className="search-division">
                <form onSubmit={handleSubmit(onFormSubmit)}>
                <Controller
                  name="division"
                  control={control} 
                  render={({ field }) => (
                <>
                <Dropdown
                  childList={divisions}
                  className="mb-3"
                  feedbackType="info"
                  isClearable
                  isRequired
                  label="Division"
                  menuPosition="bottom-right"
                  placeholder="Search..."
                  selection="single"
                  selectedValue={field.value}
                  setSelectedValue={(value) => {
                    field.onChange(value);
                    handleDivisionChange(value);
                  }}
                  size="medium"
                  style={{}}
                />
                {errors['division'] && <span className="error">This field is required</span>}
                </>
                )}
                />
                <Controller
                  name="function"
                  control={control} 
                  render={({ field }) => (
                <>
                <Dropdown
                  childList={functions}
                  className="mb-3"
                  feedbackType="info"
                  isClearable
                  isRequired
                  label="Function"
                  menuPosition="bottom-right"
                  placeholder="Search..."
                  selection="single"
                  selectedValue={field.value}
                  setSelectedValue={(value) => {
                    field.onChange(value);
                    handleFunctionChange(value);
                  }}
                  size="medium"
                  style={{}}
                />
                {errors['function'] && <span className="error">This field is required</span>}
                </>
                )}
                />
                <Controller
                  name="role"
                  control={control} 
                  render={({ field }) => (
                <>
                <Dropdown
                  childList={roles}
                  className="mb-3"
                  feedbackType="info"
                  isClearable
                  isRequired
                  label="Role"
                  menuPosition="bottom-right"
                  placeholder="Search..."
                  selection="single"
                  selectedValue={field.value}
                  setSelectedValue={(value) => {
                    field.onChange(value);
                    handleRoleChange(value);
                  }}
                  size="medium"
                  style={{}}
                />
                {errors['role'] && <span className="error">This field is required</span>}
                </>
                )}
                />
                </form>
              </div>
            )}
            {!selectedId && ( <hr
              className="custom-hr"
              style={{ marginBottom: "10px", marginTop: "16px" }}
            /> )}
            {!selectedId && (
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  className=""
                  size="large"
                  style={{}}
                  onClick={gotoMyidmPage}
                  text="Cancel"
                  variant="tertiary"
                />
                <Button
                  className=""
                  size="large"
                  style={{}}
                  onClick={handleSubmit(onFormSubmit)}
                  text="Request Access"
                  variant="primary"
                />
              </div>
            )}
            <div>
              <div>
                <Modal
                  auxiliaryButtonProps={{
                    onClick: function Xs() {},
                    size: "medium",
                    text: "Button",
                    variant: "auxiliary",
                  }}
                  className=""
                  closeOnOutsideClick
                  footerProps={{
                    size: "medium",
                    type: "primary",
                  }}
                  linkProps={{
                    iconLeading: "",
                    iconTrailing: "arrow_forward",
                    label: "Link",
                    onClick: function Xs() {},
                    size: "medium",
                  }}
                  notificationsProps={null}
                  onCloseModal={function Xs() {}}
                  primaryButtonProps={{
                    onClick: function Xs() {},
                    size: "medium",
                    text: "Button",
                    variant: "primary",
                  }}
                  secondaryButtonProps={{
                    onClick: function Xs() {},
                    size: "medium",
                    text: "Button",
                    variant: "secondary",
                  }}
                  showAuxiliaryButton
                  showLink
                  showSlot
                  showTertiaryButton
                  style={{}}
                  tertiaryButtonProps={{
                    onClick: function Xs() {},
                    size: "medium",
                    text: "Button",
                    variant: "tertiary",
                  }}
                  text="Does the menu have all of the core single-serve flavors in the assortment (regardless of package type)?"
                  title="Title Does the menu have all of the core single-serve flavors in the assortment (regardless of package type)"
                  type="fluid"
                  viewPort="desktop"
                >
                  <Slot
                    detail="Use this placeholder to embed an instance of the library or your local component."
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                    title="Slot component"
                  />
                </Modal>
              </div>
            </div>
            
            {selectedId && (
              <ArfFormAttributes
                selectedId={selectedId}
                setSelectRequest={getActionInfo} modeType={mode}
              />
            )}
          </div>
        </div>
      </div> */}
      <ToastContainer
      position="bottom-center"
      data={toasts}
      removeToast={removeToast}
    />
    </div>
  );
};

export default SearchRequestsView;
